// ToastService.js
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

// Default config (you can adjust)
toastr.options = {
  positionClass: 'toast-top-right',
  closeButton: true,
  progressBar: true,
  timeOut: 3000,
};

const showToast = (message, type = 'success') => {
  switch (type) {
    case 'success':
      toastr.success(message);
      break;
    case 'error':
      toastr.error(message);
      break;
    case 'info':
      toastr.info(message);
      break;
    case 'warning':
      toastr.warning(message);
      break;
    default:
      toastr.info(message);
  }
};

export default showToast;
